import "./Footer.css";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import fbIcon from "../../../assets/icons/social/facebook.png";
import instIcon from "../../../assets/icons/social/inst.png";
import tiktokIcon from "../../../assets/icons/social/tik-tok.png";
import twitterIcon from "../../../assets/icons/social/twitter.png";
import packageJson from "../../../../package.json";

export default function Footer() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language || "en";

  return (
    <footer className="footer" role="contentinfo">
      <div className="footer__inner">
        {/* 1) Logo + name */}
        <section className="footer__col footer__brand">
          <h3 className="section__title">Telviora</h3>

          <p className="footer__tagline">Global Travel Connectivity</p>

          <h3 className="section__title">{t("footer.legal")}</h3>

          <Link to={`/${lang}/terms`} className="footer__privacy-link">
            {t("footer.terms")}
          </Link>
          <Link to={`/${lang}/privacy-policy`} className="footer__privacy-link">
            {t("footer.privacy")}
          </Link>
        </section>

        {/* 2) Offices / Contact */}
        <section className="footer__col footer__offices" aria-label="Offices">
          <h3 className="section__title">{t("nav.contact")}</h3>
          <div className="offices__grid">
            <div className="office">
              <p className="office__addr">
                Telviora by Mobile World DWC LLC
                <br />
                <br />
                Dubai South, Dubai, UAE
              </p>
              <p className="office__phone">contact@telviora.com</p>

              <div className="social-row">
                <a
                  className="social__link"
                  href="https://www.instagram.com/telviora.esimdata"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  <img src={instIcon} alt="" className="social__icon" />
                </a>

                <a
                  className="social__link"
                  href="https://www.twitter.com/telviora"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="X"
                >
                  <img src={twitterIcon} alt="" className="social__icon" />
                </a>

                <a
                  className="social__link"
                  href="https://www.tiktok.com/@telviora.esim.dat"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="TikTok"
                >
                  <img src={tiktokIcon} alt="" className="social__icon" />
                </a>

                <a
                  className="social__link"
                  href="https://www.facebook.com/Telviora"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  <img src={fbIcon} alt="" className="social__icon" />
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>

      <div className="footer__bar">
        <small>© {new Date().getFullYear()} Telviora. {t("footer.rights")} <span className="footer__version"> v{packageJson.version}</span></small>
      </div>
    </footer>
  );
}
